import Vue from 'vue';

import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';
import EdSectionCourseMaterials from '@/content/components/ed-section-course-materials/ed-section-course-materials.vue';
import EdPdfZoomControls from '@/courses/components/ed-pdf-zoom-controls/ed-pdf-zoom-controls.vue';
import EdSectionProjectsTree from '@/content/components/ed-section-projects-tree/ed-section-projects-tree.vue';
import Component from 'vue-class-component';
import { Mixins, Prop , Watch} from 'vue-property-decorator';
import { SectionMixin } from '@/courses/mixins/section.mixin';
import { COURSE_EVENTS } from '@/content/values/events';
import { ED_CONTEXT_MENU_EVENTS } from '@/plugins/ed-context-menu/ed-context-menu.values';
import { Status } from '@/models/status.model';
import { PRESENTATION_COURSE_TAB_EVENT } from '@/content/values/ed-presentation-mode.values';
import { IClassContentPreferences } from '@/preferences/interfaces/class-content-preferences.interface';
import KEYS from '@/values/keys';
import { Preference } from '@/preferences/models/preference.model';
import { PREFERENCES_KEYS, PREFERENCES_STORE } from '@/preferences/values/preferences.values';
import { IOrganizationPreferences } from '@/preferences/interfaces/organization-preferences.interface';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import EdPdfPrint from '@/courses/components/ed-pdf-print/ed-pdf-print.component.vue';
import EdPresentationModeUserBoardTitle from '@/content/components/ed-presentation-mode/ed-presentation-mode-user-board-title/ed-presentation-mode-user-board-title.component.vue';
import { ContentType } from '@/content/types/content.types';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';
import { SECTION_OPTIONS_ROOT_TEMPLATES } from '@/content/values/sections';
import { SectionsProvider } from '@/content/providers/sections.provider';
import EdFullScreen from '@/courses/components/ed-full-screen/ed-full-screen.vue';
import EdSettingsMenu from '../ed-settings-menu/ed-settings-menu.component.vue';
import { EdContextMenuOptionsModel } from '@/plugins/ed-context-menu/ed-context-menu.plugin';

@Component({
  components: {
    EdSectionCourseMaterials,
    EdPdfZoomControls,
    EdContentSectionControls: () => import(/* EdContentSectionControls */'@/courses/components/ed-content-section-controls/ed-content-section-controls.component.vue'),
    EdPdfPrint,
    EdSectionProjectsTree,
    EdPresentationModeUserBoardTitle,
    EdFunSections: () => import(/* EdFunSections */'@/sections/components/ed-fun-sections/ed-fun-sections.component.vue'),
    EdFillerSections: () => import(/* EdFillerSections */'@/sections/components/ed-filler-sections/ed-filler-sections.component.vue'),
    EdContentSections: () => import(/* EdContentSections */'@/sections/components/ed-content-sections/ed-content-sections.component.vue'),
    EdAdditionalSections: () => import(/* EdAdditionalSections */'@/sections/components/ed-additional-sections/ed-additional-sections.component.vue'),
    EdFullScreen,
    EdSettingsMenu,
    EdDeckLibrarySections: () => import(/* EdDeckLibrarySections */'@/sections/components/ed-deck-library-sections/ed-deck-library-sections.component.vue'),
  }
})
class EdCourseContentSidebar extends Mixins(SectionMixin) {
  
  @Prop() readonly mode: COURSE_MODE;
  @Prop() readonly params: any;
  @Prop() readonly useStorage: boolean;
  @Prop() readonly status: Status;
  @Prop() readonly hasEditButton: boolean;

  @Prop({ default: false }) readonly isHome: boolean;
  @Prop({ default: true }) readonly showHeader: boolean;
  @Prop({ default: true }) readonly courseInfoHeader: boolean;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: false }) readonly hasCalendar: boolean;
  @Prop({ default: false }) readonly showBuilderData: boolean;
  @Prop({ default: true }) readonly allowEditComponents: boolean;

  public sectionOptions: any = null;
  public treeID: string = 'EdLessonResumeTree';
  public showAllContent: boolean = false;
  public readonly onModeChanged: string = 'onModeChanged';
  public sidebarCourseId: number;

  get isEditionMode() {
    return this.mode === COURSE_MODE.EDIT;
  }

  get hasContent() {
    return this.course && this.course.sections ? this.course.sections.length > 0 : false;
  }

  get hasProjects() {
    return this.course.projects ? this.course.projects.length > 0 : false;
  }

  get isPresentationModeTeacher() {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get coursePreferences(): Preference[] {
    let preferences = [];
    let classId = this.classId ? this.classId : 0;
    if(this.courseId) {
      let data: IClassContentPreferences[] = this.$store.state.PreferencesStore.classContentPreferences;
      let found = data.find(d => d.classId == classId && d.contentId == this.courseId);
      if(found) return found.preferences;
    }
    return preferences;
  }

  get canSetShowAllContent() {
    let role = this.$store.state.AuthStore.role;
    if(role == KEYS.ROLES.BUYER) {
      let preference = this.coursePreferences
        .find(p => p.preferenceName == PREFERENCES_KEYS.TIME_FRAME_CONTENT_ENABLED_BY_TEACHER);
      if(preference) return preference.preferenceValue == 'false';
    }
    return false;
  }
  
  get showAdditionalContent() {
    let role = this.$store.state.AuthStore.role;
    if(role === KEYS.ROLES.PUBLISHER) {
      if(this.isPresentationModeTeacher)  //Hide when presentation mode
        return false
      if(this.showBuilderData)            //Show when builder data  
        return true;
      return !this.isTemplateContent && this.isEditionMode //Show when not a template and in edition mode
    }
    return false;
  }

  get showAllPreference() {
    let role = this.$store.state.AuthStore.role;
    if(role == KEYS.ROLES.BUYER) {
      let data: IClassContentPreferences[] = this.$store.state.PreferencesStore.userContentPreferences;
      if(data) {
        let userPref = data.find(d => d.classId == this.classId && d.contentId == this.courseId);
        if(userPref) {
          let preference = userPref.preferences
            .find(p => p.preferenceName == PREFERENCES_KEYS.TIME_FRAME_CONTENT_ENABLED_BY_STUDENT);
            if(preference) return preference.preferenceValue == 'false';
        }
      }
    }
    return false;
  }

  get tooltipShowAllPreference() {
    let tooltip = '';
    if(this.course.organizationId) {
      let organizationsPref: IOrganizationPreferences[] = this.$store.state.PreferencesStore.organizationPreferences;
      let item = organizationsPref.find(p => p.organizationId == this.course.organizationId);
      if(item) {
        let pref = item.preferences.find(p => p.preferenceName == PREFERENCES_KEYS.TIME_FRAME_CONTENT_VIEW_START);
        tooltip = String(this.$i18n.t('courses.info.showAllTooltip', { timeframe: pref.preferenceValue }));
      }
    }
    return tooltip;
  }

  get isWebView() {
    return this.$store.state.AppStore.webview && this.$Auth.Store.isPublisher;
  }

  get hasPresentingTitle(): boolean {
    const isTeacherScreenUser = this.$store.state.MeetingsStore.currentBoardUser.isTeacher;
    if(this.isWhiteboardTransparency && (isTeacherScreenUser || this.isBoardSectionHomework) && this.isWebView) {
      return true;
    } else {
      return false;
    }
  }

  get canShowCourseMaterials() {
    return this.getCanShowSection(this.course.materialsList);
  }

  get canShowProjects() {
    return this.getCanShowSection(this.course.projects) && !this.isPresentationModeTeacher;
  }

  get content(): Section[] {
    if (!this.course?.sections) {
      return [];
    }
    return this.course.sections.filter(
      s => s.fixedSection !== 'FUN' && s.fixedSection !== 'FILLERS' && s.fixedSection !== 'ADDITIONAL'
    );
  }

  get isTemplateContent() {
    return this.contentType === 'TEMPLATE';
  }
  
  get isAllowedToEditComponents() {
    return this.contentType === 'TEMPLATE' && this.allowEditComponents;
  }

  get lessonCounter() {
    let count = null;
    if(this.isTemplateContent) {
      count = SectionProvider.getLessonCounter(this.content || []);
    }
    return count;
  }

  get menuAddOptions() {
    if(this.isTemplateContent) {
      return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_ROOT_TEMPLATES], this.$i18n);
    }

    const i18n: any = this.$i18n;
    return SectionsProvider.getCreateObjectMenuContent(
      i18n
    );
  }

  get componentParams() {
    return {
      courseId: this.courseID,
      classId: this.classID,
      components: this.course.eduacComponents
    }
  }

  getCanShowSection(list) {
    if(this.status.load) {
      if(this.isEditionMode) {
        return true;
      }
      return list.length > 0;
    } 
    return false;
  }

  getSidebarState() {
    if(this.useStorage && !this.isPresentationModeTeacher) {
      let courseId = this.courseID;
      let classId = this.classID;
      let folders: number[] = this.getFoldersStorage();
      let secSelected, objSelected, secOpened: any = {};
      let sectionId = null;
      let materialId = this.getMaterialInStorage();
      let projectId = this.getProjectInStorage();
      
      if(folders.length > 0) {
        folders.forEach((f, i) => {
          secOpened = {  sectionId: f, opened: true, courseId , classId};
          if(i == (folders.length - 1)) {
            secSelected = { sectionId: f, courseId , classId};
          }
        });
        sectionId = this.getSectionInStorage();
        objSelected = { sectionId, courseId , classId};
      } else {
        let section = this.course.sections[0];
        let fId = section ? section.sectionId : null;
        secSelected = { sectionId: fId, courseId , classId};
        secOpened = {  sectionId: fId, opened: true, courseId , classId};
        objSelected = { sectionId, opened: false, courseId , classId};
        if(fId) this.setFolderInStorage(fId);
      }
      this.$edEventBus.$emit(COURSES_EVENTS.SECTION_OPENED, secOpened);
      this.setTeacherPosition({classId, isFolder: true, sectionId: secOpened.sectionId, courseId });
      this.$edEventBus.$emit(COURSES_EVENTS.SECTION_SELECTED, secSelected);
      if(sectionId){
        this.goToSectionPreview({sectionId , courseId , classId, title: this.course.title});
      }
      
      this.$edEventBus.$emit(COURSE_EVENTS.SECTION_MATERIAL_SELECTED, secSelected);
      
      if(materialId){
        this.goToMaterialPreview({materialId, courseId , classId, title: this.course.title});
      }

      this.$edEventBus.$emit(COURSES_EVENTS.PROJECT_SELECTED, secSelected);

      if(projectId){
        this.goToProjectPreview({projectId, courseId , classId});
      }

    }
  }

  onControlsModeChanged(mode) {
    this.$emit(this.onModeChanged, mode);
  }

  checkParams(){
    if(this.params){
      let params = Object.keys(this.params);
      params.forEach((key) => {
        if(this[key] !== null){
          this[key] = this.params[key];
        }
      });
    }
  }

  closeEdContextMenu() {
    this.$EdContextMenu.$emit(ED_CONTEXT_MENU_EVENTS.CLOSE_CONTEXT_MENU,{});
  }

  showAllContentChanged() {
    this.$store.dispatch(
      PREFERENCES_STORE.ACTIONS.SAVE_USER_CONTENT_PREFERENCES,
      {
        params: {
          classId: this.classId ? this.classId : 0,
          contentId: this.courseId,
          userId: this.$store.state.AuthStore.user.id
        },
        preferences: [{
          preferenceName: PREFERENCES_KEYS.TIME_FRAME_CONTENT_ENABLED_BY_STUDENT,
          preferenceValue: String(!this.showAllContent)
        }]
      }
    );
    this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_WIDGET_COURSE, {
      courseId: this.courseId,
      classId: this.classId
    });
  }

  onOpenSubjectCalendar() {
    SectionProvider.openSubjectCalendar(this.courseId, this.classID);
  }

  selectAddOption(optionSelected = new EdContextMenuOptionsModel({})) {
    this.goToCreateObject({
      code: optionSelected.code,
      parentId: -1,
      contentId: this.courseID,
      classId: this.classID,
      minDate: null,
      contentType: 'SUBJECT',
    });
  }

  /* Watch */
  @Watch('isEditionMode', { immediate: true, deep: true })
  setEditionMode(value: boolean) {
    this.sectionOptions = new EdSectionOptions(value);
  }

  @Watch('course.sections', { immediate: false, deep: true })
  updateSideCourse() {
    if(this.isEditionMode) {
      this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_ON_SELECT_DUPLICATED_COURSE, 
      { courseId: this.courseID , classId: this.classID });
      this.$emit('refreshTasks', this.courseID);
    }
  }

  @Watch('course.materials', { immediate: false, deep: true })
  updateSideCourses() {
    if(this.isEditionMode) {
      this.$edEventBus.$emit(COURSES_EVENTS.REFRESH_ON_SELECT_DUPLICATED_COURSE, 
      { courseId: this.courseID , classId: this.classID });
    }
  }

  /* Hooks */
  created() {
    this.sectionOptions = new EdSectionOptions(this.isEditionMode);
    this.checkParams();
  }

  mounted() {
    this.getSidebarState();
    this.showAllContent = this.showAllPreference;
    this.$edEventBus.$on(`${PRESENTATION_COURSE_TAB_EVENT}${this.course.id}`, this.getSidebarState);
    this.$edEventBus.$on('refreshTree', () => {
      this.status.setEmpty();
      setTimeout(() => {
        this.status.setLoad();
      }, 100);
    });
    this.sidebarCourseId = this.course.id;
    this.$edEventBus.$emit( SCREEN_MIRRORING_EVENTS.RESET_USER_NAVIGATION, this.course.id, this.course.classId);
  }

  beforeDestroy() {
    this.$edEventBus.$off(`${PRESENTATION_COURSE_TAB_EVENT}${this.sidebarCourseId}`, this.getSidebarState);
  }

}

export default Vue.component('ed-course-content-sidebar', EdCourseContentSidebar);